import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Table, Input, Space, Typography, Descriptions, message, Modal } from 'antd';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import TempleStatisticsForm from './TempleStatisticsForm';
import formB from './formB.png';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts'; // ต้องนำเข้า vfs_fonts.js ที่คุณสร้างเอง
import dayjs from 'dayjs';


const { Title } = Typography;

function getCurrentYear() {
  return new Date().getFullYear(); // เช่น 2025
}

const TempleDetail = () => {
  const { id } = useParams();
  const [temple, setTemple] = useState(null);
  const [monks, setMonks] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [year, setYear] = useState(2025);
  const [pdfDataUrl, setPdfDataUrl] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [templeStatistic, setTempleStatistic] = useState(null);
  const [formYear, setFormYear] = useState(2025); //ปีที่จะพิมพ์ข้อมูล ค่าเริ่มต้นคือ 2025

  useEffect(() => {
    const fetchTemple = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/temples/${id}/with-monks`);
        setTemple(res.data.temple[0]);
        setMonks(res.data.monks);
      } catch (err) {
        console.error(err);
      }
    };
    fetchTemple();
  }, [id]);


  useEffect(() => {

    // ดึงปีปัจจุบันออกมา
    const year = getCurrentYear();
    setYear(year);

    if (id && year) {
      axios
        .get(`${API_BASE_URL}/api/temple-statistics/check/${id}/${year}`)
        .then((res) => {
          setIsEdit(res.data.isEdit); // true = มีข้อมูลเดิม, false = ยังไม่มี
        })
        .catch((err) => {
          console.error(err);
          message.error("ตรวจสอบข้อมูลล้มเหลว");
        });
    }
  }, [id, year]);

  const setCurrentYear = (value) => {
    setYear(value)
  }


  const columns = [
    {
      title: 'ฉายา',
      dataIndex: 'dharma_name',
      key: 'dharma_name',
    },
    {
      title: 'ชื่อ',
      dataIndex: 'first_name_th',
      key: 'first_name_th',
    },
    {
      title: 'นามสกุล',
      dataIndex: 'last_name_th',
      key: 'last_name_th',
    },
    {
      title: 'วันเกิด',
      dataIndex: 'birthdate',
      key: 'birthdate',
      render: (date) => date ? new Date(date).toLocaleDateString() : '-',
    },
    {
      title: 'วันที่บวช',
      dataIndex: 'ordination_date',
      key: 'ordination_date',
      render: (date) => date ? new Date(date).toLocaleDateString() : '-',
    },
  ];

  const filteredMonks = monks.filter((monk) => {
    const fullName = `${monk.first_name_th} ${monk.last_name_th}`.toLowerCase();
    const dharma = monk.dharma_name?.toLowerCase() || '';
    return (
      fullName.includes(searchText.toLowerCase()) ||
      dharma.includes(searchText.toLowerCase())
    );
  });

  async function fetchTempleStatistic(templeId, year) {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/temple-statistics/${templeId}/${formYear}`);
      //console.log('statistic', res.data);
      const statisticData = {
        ...res.data,
        sendAt: res.data.sendAt ? dayjs(res.data.sendAt, 'YYYY-MM-DD') : null
      };

      //setTempleStatistic(statisticData)

      return statisticData;

    } catch (error) {
      message.error('ไม่สามารถโหลดข้อมูลเก่าได้ หรือยังไม่มีสถิติของปีปัจจุบัน');
      return null;
    }
  }


  const mm = mm => mm * 2.83465;

  async function printPDF(temple) {

    // ดึงปีปัจจุบันออกมา
    const year = formYear ? formYear : getCurrentYear();
    const statistic = await fetchTempleStatistic(temple.id, year);
    //console.log('สถิติ', statistic);

    const templeStatistic = statistic;

    if (!templeStatistic) {
      templeStatistic = {};
    }

    const backgroundBase64 = await toBase64(formB);

    var docDefinition = {
      version: '1.5',
      subset: 'PDF/A-3a',
      tagged: true,
      displayTitle: true,
      // a string or { width: number, height: number }
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'portrait',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [10, 10, 10, 10],
      info: {
        title: `${temple.name}-บัญชีกลางปีวัดธรรมยุต`
      },
      background: [
        {
          image: backgroundBase64,
          width: 595.28, // A4 width in points
          absolutePosition: { x: 0, y: 0 },
        },
      ],
      content: [
        {
          text: `${templeStatistic.sender_name ? toThaiDigits(templeStatistic.sender_name) : '-'}`, //พระที่นำส่งข้อมูล
          absolutePosition: {
            x: mm(35), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.sendAt ? toThaiDigits(formatThaiDate(templeStatistic.sendAt, 'day')) : '-'}`, //วันที่ส่งข้อมูล
          absolutePosition: {
            x: mm(120), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.sendAt ? toThaiDigits(formatThaiDate(templeStatistic.sendAt, 'month')) : '-'}`, //เดือนที่ส่งข้อมูล
          absolutePosition: {
            x: mm(150), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.sendAt ? toThaiDigits(formatThaiDate(templeStatistic.sendAt, 'year')) : '-'}`, //ปีที่ส่งข้อมูล
          absolutePosition: {
            x: mm(186), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${temple.name}`, //ชื่อวัด
          absolutePosition: {
            x: mm(38), // 30 mm จากซ้าย
            y: mm(38), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.moo)}`, //บ้านเลขที่ หมู่ที่
          absolutePosition: {
            x: mm(100), // 30 mm จากซ้าย
            y: mm(38), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.address}`, //บ้าน
          absolutePosition: {
            x: mm(168), // 30 mm จากซ้าย
            y: mm(38), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.subdistrict}`, //ตำบล
          absolutePosition: {
            x: mm(38), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.district}`, //อำเภอ
          absolutePosition: {
            x: mm(82), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.province}`, //จังหวัด
          absolutePosition: {
            x: mm(136), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.postal_code ? temple.postal_code : '-')}`, //รหัสไปรษณีย์
          absolutePosition: {
            x: mm(179), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.phone_number)}`, //เบอร์โทรศัพท์
          absolutePosition: {
            x: mm(92), // 30 mm จากซ้าย
            y: mm(54), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_name)}`, //นามเจ้าอาวาส
          absolutePosition: {
            x: mm(52), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_old_name)}`, //นามเดิม
          absolutePosition: {
            x: mm(125), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_dharma_name)}`, //ฉายาเจ้าอาวาส
          absolutePosition: {
            x: mm(184), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_dharma_name)}`, //ฉายาเจ้าอาวาส
          absolutePosition: {
            x: mm(184), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_age ? temple.abbot_age : '-')}`, //อายุเจ้าอาวาส
          absolutePosition: {
            x: mm(34), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_pansa ? temple.abbot_pansa : '-')}`, //พรรษา
          absolutePosition: {
            x: mm(61), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_buddhist_education ? temple.abbot_buddhist_education : '-')}`, //วิทยฐานะทางธรรม
          absolutePosition: {
            x: mm(101), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_education ? temple.abbot_education : '-')}`, //วุฒิทางโลก
          absolutePosition: {
            x: mm(162), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_position ? temple.abbot_position : '-')}`, //ตำแหน่งทางการปกครองหรือพระอุปัชฌาย์
          absolutePosition: {
            x: mm(90), // 30 mm จากซ้าย
            y: mm(78.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.monks_count) : '0'}`, //จำนวนพระภิกษุ
          absolutePosition: {
            x: mm(56), // 30 mm จากซ้าย
            y: mm(86), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.novices_count) : '0'}`, //จำนวนสามเณร
          absolutePosition: {
            x: mm(110), // 30 mm จากซ้าย
            y: mm(86), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.temple_students_count) : '0'}`, //จำนวนศิษย์วัด
          absolutePosition: {
            x: mm(174), // 30 mm จากซ้าย
            y: mm(86), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.pariyatti_count) : '0'}`, //ภิกษุสามเณรเปรียญ(รูป)
          absolutePosition: {
            x: mm(80), // 30 mm จากซ้าย
            y: mm(94), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.pariyatti_detail ? toThaiDigits(templeStatistic.pariyatti_detail) : '-'}`, //แต่ละประโยคมีจำนวนดังนี้.-
          absolutePosition: {
            x: mm(27), // 30 mm จากซ้าย
            y: mm(102), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_naktham3_count ? toThaiDigits(templeStatistic.monks_naktham3_count) : '-'}`, //ภิกษุนักธรรมเอก
          absolutePosition: {
            x: mm(77), // 30 mm จากซ้าย
            y: mm(110), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.novices_naktham3_count ? toThaiDigits(templeStatistic.novices_naktham3_count) : '-'}`, //สามเณรนักธรรมเอก
          absolutePosition: {
            x: mm(175), // 30 mm จากซ้าย
            y: mm(110), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_patimokkha_count ? toThaiDigits(templeStatistic.monks_patimokkha_count) : '-'}`, //ภิกษุปาฏิโมกข์
          absolutePosition: {
            x: mm(77), // 30 mm จากซ้าย
            y: mm(118), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_over10_pansa_count ? toThaiDigits(templeStatistic.monks_over10_pansa_count) : '-'}`, //มีพรรษาพ้นสิบ
          absolutePosition: {
            x: mm(175), // 30 mm จากซ้าย
            y: mm(118), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_with_titles_count ? toThaiDigits(templeStatistic.monks_with_titles_count) : '-'}`, //ภิกษุทรงสมณศักดิ์
          absolutePosition: {
            x: mm(75), // 30 mm จากซ้าย
            y: mm(126), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monk_titles_detail ? toThaiDigits(templeStatistic.monk_titles_detail) : '-'}`, //ภิกษุทรงสมณศักดิ์
          absolutePosition: {
            x: mm(27), // 30 mm จากซ้าย
            y: mm(134), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.land_temple_rai ? toThaiDigits(templeStatistic.land_temple_rai) : '-'}`, //ที่ดินตั้งวัด
          absolutePosition: {
            x: mm(57), // 30 mm จากซ้าย
            y: mm(142), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.land_dharma_rai ? toThaiDigits(templeStatistic.land_dharma_rai) : '-'}`, //ที่ดินของวัด (ที่ธรณีสงฆ์)
          absolutePosition: {
            x: mm(162), // 30 mm จากซ้าย
            y: mm(142), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.type ? toThaiDigits(temple.type) : '-'}`, //วัดเป็นพัทธสีมา หรือวิสุงคามสีมา
          absolutePosition: {
            x: mm(162), // 30 mm จากซ้าย
            y: mm(149), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.established_year ? toThaiDigits(temple.established_year) : '-'}`, //ตั้งวัดเมื่อ (พ.ศ.)
          absolutePosition: {
            x: mm(70), // 30 mm จากซ้าย
            y: mm(158), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.total_former_abbots ? toThaiDigits(templeStatistic.total_former_abbots) : '-'}`, //มีเจ้าอาวาสมาแล้ว (รูป)
          absolutePosition: {
            x: mm(163), // 30 mm จากซ้าย
            y: mm(158), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.preach_on_buddha_days ? toThaiDigits(templeStatistic.preach_on_buddha_days) : '-'}`, //มีการแสดงธรรมทุกวันธรรมสวนะ
          absolutePosition: {
            x: mm(103), // 30 mm จากซ้าย
            y: mm(166), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.listeners_in_rainy ? toThaiDigits(templeStatistic.listeners_in_rainy) : '-'}`, //วันหนึ่งอย่างมากในพรรษา
          absolutePosition: {
            x: mm(86), // 30 mm จากซ้าย
            y: mm(173), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.listeners_out_rainy ? toThaiDigits(templeStatistic.listeners_out_rainy) : '-'}`, //วันหนึ่งอย่างมากนอกพรรษา
          absolutePosition: {
            x: mm(170), // 30 mm จากซ้าย
            y: mm(173), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.religious_assets ? toThaiDigits(templeStatistic.religious_assets) : '-'}`, //ศาสนวัตถุสำคัญของวัด
          absolutePosition: {
            x: mm(30), // 30 mm จากซ้าย
            y: mm(188), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.religious_structures ? toThaiDigits(templeStatistic.religious_structures) : '-'}`, //ศาสนสถานของวัด
          absolutePosition: {
            x: mm(55), // 30 mm จากซ้าย
            y: mm(197), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.has_priyatti_school ? toThaiDigits(templeStatistic.has_priyatti_school) : '-'}`, //มีโรงเรียนปริยัติธรรม
          absolutePosition: {
            x: mm(69), // 30 mm จากซ้าย
            y: mm(211), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.priyatti_students_count ? toThaiDigits(templeStatistic.priyatti_students_count) : '-'}`, //จำนวนนักเรียนปริยัติธรรม
          absolutePosition: {
            x: mm(177), // 30 mm จากซ้าย
            y: mm(211), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.meditation_training ? toThaiDigits(templeStatistic.meditation_training) : '-'}`, //มีการอบรมกรรมฐาน
          absolutePosition: {
            x: mm(68), // 30 mm จากซ้าย
            y: mm(220), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.public_benefit_activity ? toThaiDigits(templeStatistic.public_benefit_activity) : '-'}`, //มีการบำเพ็ญสาธารณสงเคราะห์
          absolutePosition: {
            x: mm(30), // 30 mm จากซ้าย
            y: mm(234), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.has_school_for_children ? toThaiDigits(templeStatistic.has_school_for_children) : '-'}`, //มีโรงเรียนสำหรับเด็กหรือฆราวาส
          absolutePosition: {
            x: mm(163), // 30 mm จากซ้าย
            y: mm(250), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.summary_monks_change ? toThaiDigits(templeStatistic.summary_monks_change) : '-'}`, //สรุปจำนวนพระภิกษุ-สามเณร-ศิษย์วัดฯ  เพิ่มขึ้น หรือลดลง
          absolutePosition: {
            x: mm(73), // 30 mm จากซ้าย
            y: mm(267), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `พิมพ์จากระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธ)`, //สรุปจำนวนพระภิกษุ-สามเณร-ศิษย์วัดฯ  เพิ่มขึ้น หรือลดลง
          absolutePosition: {
            x: mm(130), // 30 mm จากซ้าย
            y: mm(287), // 50 mm จากบน 
          },
          fontSize: 13,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
      ],
      defaultStyle: {
        font: 'THSarabunNew'
      }
    };


    pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
      setPdfDataUrl(dataUrl);
      setIsModalVisible(true);
    });

  }

  //แปลงเลขอาราบิค ---> เลขไทย
  function toThaiDigits(input) {
    const str = String(input); // แปลงเป็น string ก่อน
    if (!/\d/.test(str)) return str;
    return str.replace(/\d/g, d => '๐๑๒๓๔๕๖๗๘๙'[d]);
  }

  //แปลงรูปเป็น Base 64
  const toBase64 = (url) =>
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      }));



  function formatThaiDate(dateInput, type) {
    const date = new Date(dateInput);
    if (isNaN(date)) return ''; // ถ้า date ไม่ถูกต้อง

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // เดือน 0-11
    const year = date.getFullYear() + 543; // แปลง ค.ศ. เป็น พ.ศ.

    if (type === 'day') {
      return `${day}`;
    } else if (type === 'month') {
      return `${getThaiMonthName(month)}`;
    } else if (type === 'year') {
      return `${year}`;
    }

    function getThaiMonthName(monthInput) {
      const thaiMonths = [
        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ];

      const monthNumber = parseInt(monthInput, 10); // แปลงเป็นตัวเลข
      if (monthNumber < 1 || monthNumber > 12) return ''; // ตรวจสอบว่าเป็น 1-12

      return thaiMonths[monthNumber - 1];
    }

  }

  function thaiToArabicDigits(input) {
    const str = typeof input === 'string' ? input : String(input);
    const thaiDigits = '๐๑๒๓๔๕๖๗๘๙';
    const arabicDigits = '0123456789';

    return str.replace(/[๐-๙]/g, t => arabicDigits[thaiDigits.indexOf(t)]);
  }


  return (
    <div>
      {temple && (
        <>
          <Card title={`รายละเอียดวัด: ${temple.name} (${temple.id})`} bordered={false}>
            <Descriptions column={1} bordered>
              <Descriptions.Item label="ชื่อวัด">{temple.name}</Descriptions.Item>
              <Descriptions.Item label="ประเภทวัด">{temple.type}</Descriptions.Item>
              <Descriptions.Item label="สังกัดนิกาย">{temple.sect}</Descriptions.Item>
              <Descriptions.Item label="หมู่ที่">{temple.moo}</Descriptions.Item>
              <Descriptions.Item label="หมู่บ้าน">{temple.address}</Descriptions.Item>
              <Descriptions.Item label="ตำบล">{temple.subdistrict}</Descriptions.Item>
              <Descriptions.Item label="อำเภอ">{temple.district}</Descriptions.Item>
              <Descriptions.Item label="จังหวัด">{temple.province}</Descriptions.Item>
              <Descriptions.Item label="รหัสไปรษณีย์">{temple.postal_code}</Descriptions.Item>
              <Descriptions.Item label="เบอร์โทรวัด">{temple.phone_number}</Descriptions.Item>
              <Descriptions.Item label="เว็บไซต์">{temple.website}</Descriptions.Item>
              <Descriptions.Item label="ปีที่ก่อตั้ง">{temple.established_year}</Descriptions.Item>
              <Descriptions.Item label="รายละเอียดเพิ่มเติม">{temple.description}</Descriptions.Item>
            </Descriptions>
          </Card>

          <Card title={`ข้อมูลเจ้าอาวาส`} bordered={false}>
            <Descriptions column={1} bordered>
              <Descriptions.Item label="ชื่อ">{temple.abbot_name}</Descriptions.Item>
              <Descriptions.Item label="นามเดิม">{temple.abbot_old_name}</Descriptions.Item>
              <Descriptions.Item label="นามสกุล">{temple.abbot_lastname}</Descriptions.Item>
              <Descriptions.Item label="ฉายา">{temple.abbot_dharma_name}</Descriptions.Item>
            </Descriptions>
            <Card title={`ประวัติการศึกษา ${temple.abbot_name}`} bordered={false}>
              <Descriptions column={1} bordered>
                <Descriptions.Item label="วิทยฐานะทางโลก">{temple.abbot_education}</Descriptions.Item>
                <Descriptions.Item label="วิทยฐานะทางธรรม">{temple.abbot_buddhist_education}</Descriptions.Item>
                <Descriptions.Item label="อายุ">{temple.abbot_age}</Descriptions.Item>
                <Descriptions.Item label="พรรษา">{temple.abbot_pansa}</Descriptions.Item>
              </Descriptions>
            </Card>
          </Card>
        </>
      )}

      <Card
        title={
          <Space style={{ justifyContent: 'space-between', width: '100%' }}>
            <Title level={5} style={{ margin: 0 }}>รายนามพระภิกษุ/สามเณร ที่สังกัดวัดนี้</Title>
            <Input.Search
              placeholder="ค้นหาชื่อหรือฉายา"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              allowClear
              style={{ width: 300 }}
            />
          </Space>
        }
      >
        <Table
          dataSource={filteredMonks}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />

        {temple && (<TempleStatisticsForm templeId={temple.id} year={formYear} isEdit={isEdit} setYear={setFormYear} printPDF={()=>printPDF(temple)} />)}

      </Card>

      <Modal
        title="แบบฟอร์มบัญชีกลางปี"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="80%"
        style={{ top: 20 }}
      >
        {pdfDataUrl && (
          <iframe
            src={pdfDataUrl}
            title="PDF"
            width="100%"
            height="600px"
            style={{ border: 'none' }}
          />
        )}
      </Modal>




    </div>
  );
};

export default TempleDetail;
